// extracted by mini-css-extract-plugin
export default {"blockchainConnection":"styles_blockchainConnection__gJ4h9"};